<terra-unit-create-bank-account-failed [originUrl]="originUrl$ | async" *ngIf="isCreateFailed$ | async else notFailed" />

<ng-template #notFailed>
  <terra-unit-create-bank-account-fill-details-step
    (dialogClosed)="onDialogClosed($event)"
     [config]="data" *ngIf="(step$ | async) === CreateUnitBankAccountStep.FillDetails" />

  <terra-unit-create-bank-account-review-step
    *ngIf="(step$ | async) === CreateUnitBankAccountStep.Review"
     (bankAccountAdded)="onBankAccountAdded($event)" />
</ng-template>

<terra-unit-bank-sticky-footer 
  [bankingProviderString]="bankingProviderString$ | async"
  [accountProvider]="accountProvider$ | async" 
/>





